import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useProfiles } from "../lib/profiles.js";
import { TwinClient } from "../lib/client"
import { validateTwinUrl } from "../lib/validation.js";
import { Page } from "../Components/page/Page.js";
import { ButtonOk } from "../Components/buttons/index.js";

export default function Login() {
  const { setProfile, setActiveProfile } = useProfiles();
  const navigate = useNavigate();
  let [ searchParams, _ ] = useSearchParams();
  
  useEffect(function writeLoginFromParams() {
    let twinUrl = searchParams.get("twin-url");
    let twinApiKey = searchParams.get("twin-api-key")
    if (twinUrl && twinUrlInput?.current) {
      twinUrlInput.current.value = twinUrl;
      validateUrl({target: twinUrlInput.current}) // HAACK
    }
    if (twinApiKey) {
      document.getElementById("twin-api-key").defaultValue = twinApiKey;
    }
  }, [searchParams]);

  async function doLogin(e) {
    e.preventDefault();
    let form = e.target;
    let formData = new FormData(form);
    let url = formData.get("url");
    let apiKey = formData.get("apiKey");
    let client = new TwinClient({url, apiKey});
    let result = await client.binder();
    // PERF(sfertman): maybe ping a lighter endpoint to verify creds
    if (!result) {
      return navigate("/login");
    } else {
      let {address, binderId} = await client.info();
      setProfile(url, {
        address,
        binderId,
        client: { url, apiKey },
      })
      setActiveProfile(url);
      return navigate("/home")
    }
  }

  let [ validUrl, setValidUrl ] = useState(null);
  function validateUrl(e) {
    let twinUrl = e.target.value;
    setValidUrl(null);

    let result = validateTwinUrl(twinUrl);
    if (result == null) {
      setValidUrl(twinUrl);
    }
  }

  let twinUrlInput = useRef(null);
  let twinApiKeyInput = useRef(null);

  return <Page>
    <div className="py-10 px-2 flex flex-col items-center justify-center ">
      <div className="p-6 max-w-1/4 min-w-96 align-center">
        <form onSubmit={doLogin}>
          <div className="grid gap-6 md:grid-rows-2">
            <div>
              <label
                htmlFor="twin-url"
                className="block mb-2 text-sm font-medium text-toda-gray">
                Account URL
              </label>
              <input
                id="twin-url"
                ref={twinUrlInput}
                type="text"
                name="url"
                onChange={validateUrl}
                onChangeCapture={validateUrl}
                data-invalid={!validUrl}
                placeholder="https://"
                className="p-1 border block w-full data-[invalid=true]:text-red-600" />
            </div>
            <div>
              <label
                htmlFor="twin-api-key"
                className="block mb-2 text-sm font-medium text-toda-gray">
                Account Access Code
              </label>
              <input
                id="twin-api-key"
                ref={twinApiKeyInput}
                type="password"
                required
                name="apiKey"
                placeholder="00000000-0000-0000-0000-000000000000"
              className="p-1 border block w-full" />
            </div>
            <div className="gap-6 flex flex-col">
              <ButtonOk type="submit" disabled={!validUrl}>
                Login
              </ButtonOk>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Page>;
}
